var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import PageAuthentication from 'src/pages/PageAuthentication';
var RoutePrivate = (function (_super) {
    __extends(RoutePrivate, _super);
    function RoutePrivate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RoutePrivate.prototype.render = function () {
        var _a = this.props, isAuthenticated = _a.isAuthenticated, Component = _a.component, props = __rest(_a, ["isAuthenticated", "component"]);
        if (isAuthenticated) {
            return React.createElement(Route, __assign({}, props, { component: Component }));
        }
        return React.createElement(Route, __assign({}, props, { render: function () { return React.createElement(PageAuthentication, { redirectPath: props.location ? props.location.pathname : undefined }); } }));
    };
    return RoutePrivate;
}(React.Component));
var mapStateToProps = function (state) { return ({
    isAuthenticated: state.auth.isSignedIn && state.workspaceMain.user,
}); };
export default connect(mapStateToProps)(RoutePrivate);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/RoutePrivate.tsx
// module id = 653
// module chunks = 0